import { classNames } from "@opensea/ui-kit"

type AsteriskTextProps = {
  className?: string
  length?: number
}

export function AsteriskText({ className, length = 6 }: AsteriskTextProps) {
  return (
    <span
      className={classNames(
        "text-text-secondary tracking-widest opacity-60",
        className,
      )}
    >
      {"\u2217".repeat(length)}
    </span>
  )
}
